import { buildMoncoBrandBlock } from "./buildMoncoBrandBlock";
import type { DrawMoncoBrandLink } from "./types";

export const drawMoncoBrandLink: DrawMoncoBrandLink = async (args) => {
  const brandBlock = await buildMoncoBrandBlock(args);
  brandBlock.draw();
};
